import { Component, OnInit } from "@angular/core";
import { encryptUsingAES256, isMobile, UtilityService } from "@core/utility.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AuthService } from "@core/auth.service";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDialogRef } from "@angular/material/dialog";
import { filter } from "rxjs/operators";
import { Router } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
@Component({
    selector: "app-merge-account-popup",
    templateUrl: "./merge-account-popup.component.html",
    styleUrls: ["./merge-account-popup.component.scss"],
    standalone: true,
    imports: [MatIcon],
})
export class MergeAccountPopupComponent implements OnInit {
  url: any;
  //chatBotUrl: any;
  liveUrl: string;

  constructor(
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<MergeAccountPopupComponent>,
    private router: Router
  ) { }

  ngOnInit() {
    const encryptedToken = encryptUsingAES256(localStorage.getItem("fbToken"));
    this.liveUrl = `https://web.lottosocial.com/merge-accounts?token=${encryptedToken}`;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.liveUrl);
  }
  goBack() {
    this.dialogRef.close();
  }
}
